import { jsx } from "react/jsx-runtime";
const HelperText = ({ text, inputId, hasError })=>hasError ? /*#__PURE__*/ jsx("p", {
        id: `${inputId}Error`,
        role: "alert",
        className: "tw-font-caption tw-text-alert-400 dark:tw-text-alert-300",
        children: text
    }) : /*#__PURE__*/ jsx("p", {
        className: "tw-font-caption tw-text-neutral-light-700 dark:tw-text-neutral-dark-500",
        children: text
    });
const components_HelperText = HelperText;
export default components_HelperText;
